export const formatTaxRatePercent = (rate) => (rate * 100).toFixed(3).replace(/\.?0+$/, '');
